

export const SpeciesInfo = ( props ) => {
    const {
        charSpecies
    } = props;

    const renderSpecies = () => {
        switch (charSpecies) {
            case "Aasimar":
                return <AasimarInfo />;
            case "Dragonborn":
                return <DragonbornInfo />;
            case "Dwarf":
                return <DwarfInfo />;
            case "Elf":
                return <ElfInfo />;
            case "Gnome":
                return <GnomeInfo />;
            case "Goliath":
                return <GoliathInfo />;
            case "Halfling":
                return <HalflingInfo />;
            case "Human":
                return <HumanInfo />;
            case "Orc":
                return <OrcInfo />;
            case "Tiefling":
                return <TieflingInfo />;
            default:
                return (
                    <div className="select-species-prompt">
                        Select a species 
                        <span className="animated-arrow"> {">"} {">"} {">"} </span>
                    </div>
                );
        }
    };    
    
    const AasimarInfo = () => {
        return (
            <>
                <h3>Aasimar</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Creature Type</td>
                            <td style={{ padding: '8px' }}>Humanoid</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Size</td>
                            <td style={{ padding: '8px' }}>Medium (about 4–7 feet tall) or Small (about 2–4 feet tall), chosen when you select this species</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Speed</td>
                            <td style={{ padding: '8px' }}>30 feet</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Celestial Resistance</td>
                            <td style={{ padding: '8px' }}>You have Resistance to Necrotic damage and Radiant damage.</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Darkvision</td>
                            <td style={{ padding: '8px' }}>You have Darkvision with a range of 60 feet.</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Healing Hands</td>
                            <td style={{ padding: '8px' }}>
                                As a Magic action, you touch a creature and roll a number of d4s equal to your Proficiency Bonus. The creature regains a number of Hit Points equal to the total rolled. Once you use this trait, you can’t use it again until you finish a Long Rest.
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Light Bearer</td>
                            <td style={{ padding: '8px' }}>You know the Light cantrip. Charisma is your spellcasting ability for it.</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Celestial Revelation</td>
                            <td style={{ padding: '8px' }}>
                                When you reach character level 3, you can transform as a Bonus Action using one of the options below (choose the option each time you transform). The transformation lasts for 1 minute or until you end it (no action required). Once you transform, you can’t do so again until you finish a Long Rest.
                                <br />
                                <strong>Once on each of your turns before the transformation ends, you can deal extra damage to one target when you deal damage to it with an attack or a spell. The extra damage equals your Proficiency Bonus, and the extra damage’s type is either Necrotic for Necrotic Shroud or Radiant for Heavenly Wings and Inner Radiance.</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Transformation Options</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Heavenly Wings:</strong> Two spectral wings sprout from your back temporarily. Until the transformation ends, you have a Fly Speed equal to your Speed.
                                <br />
                                <strong>Inner Radiance:</strong> Searing light temporarily radiates from your eyes and mouth. For the duration, you shed Bright Light in a 10-foot radius and Dim Light for an additional 10 feet, and at the end of each of your turns, each creature within 10 feet of you takes Radiant damage equal to your Proficiency Bonus.
                                <br />
                                <strong>Necrotic Shroud:</strong> Your eyes briefly become pools of darkness, and flightless wings sprout from your back temporarily. Creatures other than your allies within 10 feet of you must succeed on a Charisma saving throw (DC 8 plus your Charisma modifier and Proficiency Bonus) or have the Frightened condition until the end of your next turn.
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Aasimar" 
                        className="link" /* Add the link class */
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };

    const DragonbornInfo = () => {
        return (
            <>
                <h3>Dragonborn</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Creature Type</td>
                            <td style={{ padding: '8px' }}>Humanoid</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Size</td>
                            <td style={{ padding: '8px' }}>Medium (about 5–7 feet tall)</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Speed</td>
                            <td style={{ padding: '8px' }}>30 feet</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Draconic Ancestry</td>
                            <td style={{ padding: '8px' }}>
                                Your lineage stems from a dragon progenitor. Choose the kind of dragon from the Draconic Ancestors table. Your choice affects your Breath Weapon and Damage Resistance traits as well as your appearance.
                                <br />
                                <strong>Draconic Ancestors:</strong>
                                <table style={{ borderCollapse: 'collapse', width: '100%', marginTop: '10px' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ padding: '8px' }}>Dragon</th>
                                            <th style={{ padding: '8px' }}>Damage Type</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style={{ padding: '8px' }}>Black</td>
                                            <td style={{ padding: '8px' }}>Acid</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '8px' }}>Blue</td>
                                            <td style={{ padding: '8px' }}>Lightning</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '8px' }}>Brass</td>
                                            <td style={{ padding: '8px' }}>Fire</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '8px' }}>Bronze</td>
                                            <td style={{ padding: '8px' }}>Lightning</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '8px' }}>Copper</td>
                                            <td style={{ padding: '8px' }}>Acid</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '8px' }}>Gold</td>
                                            <td style={{ padding: '8px' }}>Fire</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '8px' }}>Green</td>
                                            <td style={{ padding: '8px' }}>Poison</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '8px' }}>Red</td>
                                            <td style={{ padding: '8px' }}>Fire</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '8px' }}>Silver</td>
                                            <td style={{ padding: '8px' }}>Cold</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '8px' }}>White</td>
                                            <td style={{ padding: '8px' }}>Cold</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Breath Weapon</td>
                            <td style={{ padding: '8px' }}>
                                When you take the Attack action on your turn, you can replace one of your attacks with an exhalation of magical energy in either a 15-foot Cone or a 30-foot Line that is 5 feet wide (choose the shape each time). Each creature in that area must make a Dexterity saving throw (DC 8 plus your Constitution modifier and Proficiency Bonus). On a failed save, a creature takes 1d10 damage of the type determined by your Draconic Ancestry trait. On a successful save, a creature takes half as much damage. This damage increases by 1d10 when you reach character levels 5 (2d10), 11 (3d10), and 17 (4d10). You can use this Breath Weapon a number of times equal to your Proficiency Bonus, and you regain all expended uses when you finish a Long Rest.
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Damage Resistance</td>
                            <td style={{ padding: '8px' }}>
                                You have Resistance to the damage type determined by your Draconic Ancestry trait.
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Darkvision</td>
                            <td style={{ padding: '8px' }}>
                                You have Darkvision with a range of 60 feet.
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Draconic Flight</td>
                            <td style={{ padding: '8px' }}>
                                When you reach character level 5, you can channel draconic magic to give yourself temporary flight. As a Bonus Action, you sprout spectral wings on your back that last for 10 minutes or until you retract the wings (no action required) or have the Incapacitated condition. During that time, you have a Fly Speed equal to your Speed. Your wings appear to be made of the same energy as your Breath Weapon. Once you use this trait, you can’t use it again until you finish a Long Rest.
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Dragonborn" 
                        className="link" /* Add the link class */
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };
    
    const DwarfInfo = () => {
        return (
            <>
                <h3>Dwarf</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Creature Type</td>
                            <td style={{ padding: '8px' }}>Humanoid</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Size</td>
                            <td style={{ padding: '8px' }}>Medium (about 4–5 feet tall)</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Speed</td>
                            <td style={{ padding: '8px' }}>30 feet</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Darkvision</td>
                            <td style={{ padding: '8px' }}>
                                You have Darkvision with a range of 120 feet.
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Dwarven Resilience</td>
                            <td style={{ padding: '8px' }}>
                                You have Resistance to Poison damage. You also have Advantage on saving throws you make to avoid or end the Poisoned condition.
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Dwarven Toughness</td>
                            <td style={{ padding: '8px' }}>
                                Your Hit Point maximum increases by 1, and it increases by 1 again whenever you gain a level.
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Stonecunning</td>
                            <td style={{ padding: '8px' }}>
                                As a Bonus Action, you gain Tremorsense with a range of 60 feet for 10 minutes. You must be on a stone surface or touching a stone surface to use this Tremorsense. The stone can be natural or worked. You can use this Bonus Action a number of times equal to your Proficiency Bonus, and you regain all expended uses when you finish a Long Rest.
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Dwarf" 
                        className="link" /* Add the link class */
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };
    
    const ElfInfo = () => {
        return (
            <>
                <h3>Elf</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Creature Type</td>
                            <td style={{ padding: '8px' }}>Humanoid</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Size</td>
                            <td style={{ padding: '8px' }}>Medium (about 5–6 feet tall)</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Speed</td>
                            <td style={{ padding: '8px' }}>30 feet</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Darkvision</td>
                            <td style={{ padding: '8px' }}>
                                You have Darkvision with a range of 60 feet.
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Elven Lineage</td>
                            <td style={{ padding: '8px' }}>
                                You are part of a lineage that grants you supernatural abilities. Choose a lineage from the Elven Lineages table. You gain the level 1 benefit of that lineage.
                                <br />
                                <strong>Elven Lineages:</strong>
                                <table style={{ borderCollapse: 'collapse', width: '100%', marginTop: '10px' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ padding: '8px' }}>Lineage</th>
                                            <th style={{ padding: '8px' }}>Level 1</th>
                                            <th style={{ padding: '8px' }}>Level 3</th>
                                            <th style={{ padding: '8px' }}>Level 5</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style={{ padding: '8px' }}>Drow</td>
                                            <td style={{ padding: '8px' }}>The range of your Darkvision increases to 120 feet. You also know the Dancing Lights cantrip.</td>
                                            <td style={{ padding: '8px' }}>Faerie Fire</td>
                                            <td style={{ padding: '8px' }}>Darkness</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '8px' }}>High Elf</td>
                                            <td style={{ padding: '8px' }}>You know the Prestidigitation cantrip. Whenever you finish a Long Rest, you can replace that cantrip with a different cantrip from the Wizard spell list.</td>
                                            <td style={{ padding: '8px' }}>Detect Magic</td>
                                            <td style={{ padding: '8px' }}>Misty Step</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '8px' }}>Wood Elf</td>
                                            <td style={{ padding: '8px' }}>Your Speed increases to 35 feet. You also know the Druidcraft cantrip.</td>
                                            <td style={{ padding: '8px' }}>Longstrider</td>
                                            <td style={{ padding: '8px' }}>Pass without Trace</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Fey Ancestry</td>
                            <td style={{ padding: '8px' }}>
                                You have Advantage on saving throws you make to avoid or end the Charmed condition.
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Keen Senses</td>
                            <td style={{ padding: '8px' }}>
                                You have proficiency in the Insight, Perception, or Survival skill.
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Trance</td>
                            <td style={{ padding: '8px' }}>
                                You don’t need to sleep, and magic can’t put you to sleep. You can finish a Long Rest in 4 hours if you spend those hours in a trancelike meditation, during which you retain consciousness.
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Elf" 
                        className="link" /* Add the link class */
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };
    
    const GnomeInfo = () => {
        return (
            <>
                <h3>Gnome</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Creature Type</td>
                            <td style={{ padding: '8px' }}>Humanoid</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Size</td>
                            <td style={{ padding: '8px' }}>Small (about 3–4 feet tall)</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Speed</td>
                            <td style={{ padding: '8px' }}>30 feet</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Darkvision</td>
                            <td style={{ padding: '8px' }}>
                                You have Darkvision with a range of 60 feet.
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Gnomish Cunning</td>
                            <td style={{ padding: '8px' }}>
                                You have Advantage on Intelligence, Wisdom, and Charisma saving throws.
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Gnomish Lineage</td>
                            <td style={{ padding: '8px' }}>
                                You are part of a lineage that grants you supernatural abilities. Choose one of the following options; whichever one you choose, Intelligence, Wisdom, or Charisma is your spellcasting ability for the spells you cast with this trait (choose the ability when you select the lineage):
                                <br />
                                <strong>Options:</strong>
                                <table style={{ borderCollapse: 'collapse', width: '100%', marginTop: '10px' }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ padding: '8px' }}>Forest Gnome</td>
                                            <td style={{ padding: '8px' }}>
                                                You know the Minor Illusion cantrip. You also always have the Speak with Animals spell prepared. You can cast it without a spell slot a number of times equal to your Proficiency Bonus, and you regain all expended uses when you finish a Long Rest. You can also use any spell slots you have to cast the spell.
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '8px' }}>Rock Gnome</td>
                                            <td style={{ padding: '8px' }}>
                                                You know the Mending and Prestidigitation cantrips. In addition, you can spend 10 minutes casting Prestidigitation to create a Tiny clockwork device (AC 5, 1 HP), such as a toy, fire starter, or music box. When you create the device, you determine its function by choosing one effect from Prestidigitation; the device produces that effect whenever you or another creature takes a Bonus Action to activate it with a touch. If the chosen effect has options within it, you choose one of those options for the device when you create it. For example, if you choose the spell’s ignite-extinguish effect, you determine whether the device ignites or extinguishes fire; the device doesn’t do both. You can have three such devices in existence at a time, and each falls apart 8 hours after its creation or when you dismantle it with a touch as a Utilize action.
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Gnome" 
                        className="link" /* Add the link class */
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };

    const GoliathInfo = () => {
        return (
            <>
                <h3>Goliath</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Creature Type</td>
                            <td style={{ padding: '8px' }}>Humanoid</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Size</td>
                            <td style={{ padding: '8px' }}>Medium (about 7–8 feet tall)</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Speed</td>
                            <td style={{ padding: '8px' }}>35 feet</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Giant Ancestry</td>
                            <td style={{ padding: '8px' }}>
                                You are descended from Giants. Choose one of the following benefits—a supernatural boon from your ancestry; you can use the chosen benefit a number of times equal to your Proficiency Bonus, and you regain all expended uses when you finish a Long Rest:
                                <br />
                                <strong>Benefits:</strong>
                                <table style={{ borderCollapse: 'collapse', width: '100%', marginTop: '10px' }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ padding: '8px' }}>Cloud’s Jaunt (Cloud Giant)</td>
                                            <td style={{ padding: '8px' }}>As a Bonus Action, you magically teleport up to 30 feet to an unoccupied space you can see.</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '8px' }}>Fire’s Burn (Fire Giant)</td>
                                            <td style={{ padding: '8px' }}>When you hit a target with an attack roll and deal damage to it, you can also deal 1d10 Fire damage to that target.</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '8px' }}>Frost’s Chill (Frost Giant)</td>
                                            <td style={{ padding: '8px' }}>When you hit a target with an attack roll and deal damage to it, you can also deal 1d6 Cold damage to that target and reduce its Speed by 10 feet until the start of your next turn.</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '8px' }}>Hill’s Tumble (Hill Giant)</td>
                                            <td style={{ padding: '8px' }}>When you hit a Large or smaller creature with an attack roll and deal damage to it, you can give that target the Prone condition.</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '8px' }}>Stone’s Endurance (Stone Giant)</td>
                                            <td style={{ padding: '8px' }}>When you take damage, you can take a Reaction to roll 1d12. Add your Constitution modifier to the number rolled and reduce the damage by that total.</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '8px' }}>Storm’s Thunder (Storm Giant)</td>
                                            <td style={{ padding: '8px' }}>When you take damage from a creature within 60 feet of you, you can take a Reaction to deal 1d8 Thunder damage to that creature.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Large Form</td>
                            <td style={{ padding: '8px' }}>
                                Starting at character level 5, you can change your size to Large as a Bonus Action if you’re in a big enough space. This transformation lasts for 10 minutes or until you end it (no action required). For that duration, you have Advantage on Strength checks, and your Speed increases by 10 feet. Once you use this trait, you can’t use it again until you finish a Long Rest.
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Powerful Build</td>
                            <td style={{ padding: '8px' }}>
                                You have Advantage on any ability check you make to end the Grappled condition. You also count as one size larger when determining your carrying capacity.
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Goliath" 
                        className="link" /* Add the link class */
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };

    const HalflingInfo = () => {
        return (
            <>
                <h3>Halfling</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Creature Type</td>
                            <td style={{ padding: '8px' }}>Humanoid</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Size</td>
                            <td style={{ padding: '8px' }}>Small (about 2–3 feet tall)</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Speed</td>
                            <td style={{ padding: '8px' }}>30 feet</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Brave</td>
                            <td style={{ padding: '8px' }}>
                                You have Advantage on saving throws you make to avoid or end the Frightened condition.
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Halfling Nimbleness</td>
                            <td style={{ padding: '8px' }}>
                                You can move through the space of any creature that is a size larger than you, but you can’t stop in the same space.
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Luck</td>
                            <td style={{ padding: '8px' }}>
                                When you roll a 1 on the d20 of a d20 Test, you can reroll the die, and you must use the new roll.
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Naturally Stealthy</td>
                            <td style={{ padding: '8px' }}>
                                You can take the Hide action even when you are obscured only by a creature that is at least one size larger than you.
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Halfling" 
                        className="link" /* Add the link class */
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };

    const HumanInfo = () => {
        return (
            <>
                <h3>Human</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Creature Type</td>
                            <td style={{ padding: '8px' }}>Humanoid</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Size</td>
                            <td style={{ padding: '8px' }}>Medium (about 4–7 feet tall) or Small (about 2–4 feet tall), chosen when you select this species</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Speed</td>
                            <td style={{ padding: '8px' }}>30 feet</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Resourceful</td>
                            <td style={{ padding: '8px' }}>
                                You gain Heroic Inspiration whenever you finish a Long Rest.
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skillful</td>
                            <td style={{ padding: '8px' }}>
                                You gain proficiency in one skill of your choice.
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Versatile</td>
                            <td style={{ padding: '8px' }}>
                                You gain an Origin feat of your choice. Skilled is recommended.
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Human" 
                        className="link" /* Add the link class */
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };

    const OrcInfo = () => {
        return (
            <>
                <h3>Orc</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Creature Type</td>
                            <td style={{ padding: '8px' }}>Humanoid</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Size</td>
                            <td style={{ padding: '8px' }}>Medium (about 6–7 feet tall)</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Speed</td>
                            <td style={{ padding: '8px' }}>30 feet</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Adrenaline Rush</td>
                            <td style={{ padding: '8px' }}>
                                You can take the Dash action as a Bonus Action. When you do so, you gain a number of Temporary Hit Points equal to your Proficiency Bonus. You can use this trait a number of times equal to your Proficiency Bonus, and you regain all expended uses when you finish a Short or Long Rest.
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Darkvision</td>
                            <td style={{ padding: '8px' }}>
                                You have Darkvision with a range of 120 feet.
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Relentless Endurance</td>
                            <td style={{ padding: '8px' }}>
                                When you are reduced to 0 Hit Points but not killed outright, you can drop to 1 Hit Point instead. Once you use this trait, you can’t do so again until you finish a Long Rest.
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Orc" 
                        className="link" /* Add the link class */
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };
    
    const TieflingInfo = () => {
        return (
            <>
                <h3>Tiefling</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Creature Type</td>
                            <td style={{ padding: '8px' }}>Humanoid</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Size</td>
                            <td style={{ padding: '8px' }}>Medium (about 4–7 feet tall) or Small (about 3–4 feet tall), chosen when you select this species</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Speed</td>
                            <td style={{ padding: '8px' }}>30 feet</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Darkvision</td>
                            <td style={{ padding: '8px' }}>
                                You have Darkvision with a range of 60 feet.
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Fiendish Legacy</td>
                            <td style={{ padding: '8px' }}>
                                You are the recipient of a legacy that grants you supernatural abilities. Choose a legacy from the Fiendish Legacies table. You gain the level 1 benefit of the chosen legacy.
                                <br />
                                <strong>Fiendish Legacies</strong>
                                <table style={{ borderCollapse: 'collapse', width: '100%', marginTop: '10px' }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ padding: '8px' }}>Legacy</td>
                                            <td style={{ padding: '8px' }}>Level 1</td>
                                            <td style={{ padding: '8px' }}>Level 3</td>
                                            <td style={{ padding: '8px' }}>Level 5</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '8px' }}>Abyssal</td>
                                            <td style={{ padding: '8px' }}>You have Resistance to Poison damage. You also know the Poison Spray cantrip.</td>
                                            <td style={{ padding: '8px' }}>Ray of Sickness</td>
                                            <td style={{ padding: '8px' }}>Hold Person</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '8px' }}>Chthonic</td>
                                            <td style={{ padding: '8px' }}>You have Resistance to Necrotic damage. You also know the Chill Touch cantrip.</td>
                                            <td style={{ padding: '8px' }}>False Life</td>
                                            <td style={{ padding: '8px' }}>Ray of Enfeeblement</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '8px' }}>Infernal</td>
                                            <td style={{ padding: '8px' }}>You have Resistance to Fire damage. You also know the Fire Bolt cantrip.</td>
                                            <td style={{ padding: '8px' }}>Hellish Rebuke</td>
                                            <td style={{ padding: '8px' }}>Darkness</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Otherworldly Presence</td>
                            <td style={{ padding: '8px' }}>
                                You know the Thaumaturgy cantrip. When you cast it with this trait, the spell uses the same spellcasting ability you use for your Fiendish Legacy trait.
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-origins#Tiefling" 
                        className="link" /* Add the link class */
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };    
    
    return (
        <>{renderSpecies()}</>
    )
}